// extracted by mini-css-extract-plugin
export default {"wrapper":"IsbnListElement_wrapper__B1OWL"};